import { useState } from 'react';

const navLinks = [
  { label: '下期预告', href: '#next' },
  { label: '待证实', href: '#unconfirmed' },
  { label: '线人风声', href: '#whispers' },
  { label: '风向标', href: '#topics' },
  { label: '常见问题', href: '#faq' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/85 backdrop-blur-md">
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:px-8">
        <a href="#top" className="flex cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <strong className="font-heading text-base font-bold tracking-wide text-foreground-950">
              黑料最新
            </strong>
            <span className="mt-1 font-label text-[10px] tracking-[0.3em] text-foreground-500">
              TEASER
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-4 md:flex">
          <span className="whitespace-nowrap font-label text-xs text-foreground-500">
            09·12 · 第 130 期预告
          </span>
          <a
            href="#subscribe"
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅预告
          </a>
        </div>

        <button
          type="button"
          aria-label="展开导航"
          onClick={() => setOpen((value) => !value)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-5 pt-2 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer whitespace-nowrap border-b border-background-100 py-3 font-label text-sm text-foreground-700"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            className="mt-4 flex cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 font-label text-sm text-background-50"
          >
            订阅预告
          </a>
        </div>
      )}
    </header>
  );
}